define(["exports", "react", "latinize", "react-highlight-words", "styled-components", "../../themes"], function (_exports, _react, _latinize, _reactHighlightWords, _styledComponents, _themes) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _react = _interopRequireDefault(_react);
  _latinize = _interopRequireDefault(_latinize);
  _reactHighlightWords = _interopRequireDefault(_reactHighlightWords);
  _styledComponents = _interopRequireDefault(_styledComponents);

  var Suggestion = _styledComponents.default.li.withConfig({
    displayName: "Row__Suggestion",
    componentId: "sc-1ea4l7f-0"
  })(["button{", ";background:", ";font-size:1.6em;padding:4px 8px;text-align:left;width:100%;display:flex;align-items:center;> span{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}&:hover,&:focus{background:", ";outline:none;}}"], _themes.resetButton, function (_ref) {
    var active = _ref.active,
        theme = _ref.theme;
    return active === 'true' ? theme.colors.lightGray : theme.colors.white;
  }, function (_ref2) {
    var theme = _ref2.theme;
    return theme.colors.lightGray;
  });

  var Row = function Row(_ref3) {
    var currentSuggestion = _ref3.currentSuggestion,
        query = _ref3.query,
        handleSuggestion = _ref3.handleSuggestion,
        name = _ref3.name,
        _ref3$rest = _ref3.rest,
        index = _ref3$rest.index,
        style = _ref3$rest.style,
        data = _ref3$rest.data;
    var currentItem = data[index];
    return /*#__PURE__*/_react.default.createElement(Suggestion, {
      active: "" + (index === currentSuggestion),
      "aria-selected": index === currentSuggestion,
      style: style
    }, /*#__PURE__*/_react.default.createElement("button", {
      tabIndex: "-1",
      id: name + "-listbox-" + currentItem.id,
      onClick: function onClick() {
        return handleSuggestion(currentItem.descricao, currentItem.id);
      }
    }, /*#__PURE__*/_react.default.createElement(_reactHighlightWords.default, {
      highlightStyle: {
        fontWeight: 'bold',
        background: 'transparent'
      },
      searchWords: [query],
      autoEscape: true,
      sanitize: _latinize.default,
      textToHighlight: currentItem.descricao
    })));
  };

  var _default = Row;
  _exports.default = _default;
});